import { render } from "./ContactAddPanel.vue?vue&type=template&id=1f3e9bc2&scoped=true"
import script from "./ContactAddPanel.vue?vue&type=script&lang=js"
export * from "./ContactAddPanel.vue?vue&type=script&lang=js"

import "./ContactAddPanel.vue?vue&type=style&index=0&id=1f3e9bc2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1f3e9bc2"

export default script